var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_user_app"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "appCode"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              attrs: {
                                placeholder:
                                  _vm.language["common.pleaseChoose"] +
                                  _vm.language["gift_user_app"],
                                disabled: _vm.appLimit.limit
                              },
                              model: {
                                value: _vm.model.appCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "appCode", $$v)
                                },
                                expression: "model.appCode"
                              }
                            },
                            _vm._l(_vm.appLimit.appCodeNameMap, function(v, k) {
                              return _c(
                                "a-select-option",
                                { key: k, attrs: { value: k, label: v } },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(v) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["category"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "category"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["category"]
                            },
                            model: {
                              value: _vm.model.category,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "category", $$v)
                              },
                              expression: "model.category"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift.qa.q"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "question"
                          }
                        },
                        [
                          _c("a-textarea", {
                            attrs: {
                              maxlength: "500",
                              "auto-size": { minRows: 2, maxRows: 5 },
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift.qa.q"]
                            },
                            model: {
                              value: _vm.model.question,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "question", $$v)
                              },
                              expression: "model.question"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift.qa.a"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "answer"
                          }
                        },
                        [
                          _c("a-textarea", {
                            attrs: {
                              maxlength: "500",
                              "auto-size": { minRows: 2, maxRows: 5 },
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift.qa.a"]
                            },
                            model: {
                              value: _vm.model.answer,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "answer", $$v)
                              },
                              expression: "model.answer"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }